import React from "react";

import Paginator from "./paginator";

import * as S from "./styles";

import IProps from "./props";

import { stepConfig } from "./utils";

const RegisterSideBar: React.FC<IProps> = ({ currentStep }) => {
  const { title, image, text } = stepConfig[currentStep] || {
    title: "",
    image: "",
    text: "Escolha uma opção para iniciar o seu cadastro",
  };

  return (
    <S.Container>
      <S.TopDash />
      <Paginator currentStep={currentStep} />
      <S.Title>{title}</S.Title>
      {image && (
        <img
          style={{ marginTop: "40px", marginBottom: "40px" }}
          alt=""
          src={image}
        />
      )}
      <S.Text>{text}</S.Text>
      <S.BottomDash />
    </S.Container>
  );
};

export default RegisterSideBar;
